import React from 'react';

/**
 * Toggle switch atom.
 */
export default function Toggle({
  checked = false,
  onChange,
  disabled = false,
  'aria-label': ariaLabel = 'Toggle',
  className = '',
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      className={`ca-toggle ${checked ? 'ca-toggle--on' : ''} ${className}`.trim()}
      onClick={() => onChange?.(!checked)}
    >
      <span className="ca-toggle__thumb" />
    </button>
  );
}
